export const currencies = [
  {
    CurrencyID: 11,
    Name: 'Australian Dollar',
    ShortName: 'AUD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 12,
    Name: 'Austrian Schilling',
    ShortName: 'ATS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 13,
    Name: 'Azerbaijan Manat until 2006',
    ShortName: 'AZM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 14,
    Name: 'Azerbaijan Manat',
    ShortName: 'AZN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 15,
    Name: 'Albanian Lek',
    ShortName: 'ALL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 16,
    Name: 'Algerian Dinar',
    ShortName: 'DZD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 17,
    Name: 'Angolan Kwanza',
    ShortName: 'AOA',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 18,
    Name: 'Argentine Peso',
    ShortName: 'ARS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 19,
    Name: 'Armenian Dram',
    ShortName: 'AMD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 20,
    Name: 'Afghanistan Afghani',
    ShortName: 'AFG',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 21,
    Name: 'Afghanistan Afghani',
    ShortName: 'AFN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 22,
    Name: 'Bangladesh Taka',
    ShortName: 'BDT',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 23,
    Name: 'Bahraini Dinar',
    ShortName: 'BHD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 24,
    Name: 'Belarus Rubles',
    ShortName: 'BYB',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 25,
    Name: 'Belarus Rubles',
    ShortName: 'BYR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 26,
    Name: 'Belgian Franc',
    ShortName: 'BEF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 27,
    Name: 'Bulgarian Lev',
    ShortName: 'BGN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 28,
    Name: 'Bolivian Boliviano',
    ShortName: 'BOB',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 29,
    Name: 'Botswanian Pula',
    ShortName: 'BWP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 30,
    Name: 'Brazilian Real',
    ShortName: 'BRL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 31,
    Name: 'Brunei Dollar',
    ShortName: 'BND',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 32,
    Name: 'Burundi Franc',
    ShortName: 'BIF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 33,
    Name: 'Hungarian Forint',
    ShortName: 'HUF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 34,
    Name: 'Venezuelan Bolivar Fuerte',
    ShortName: 'VEF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 35,
    Name: 'Venezuela Bolivar',
    ShortName: 'VEB',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 36,
    Name: 'Vietnam Dong',
    ShortName: 'VND',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 37,
    Name: 'Gambian Dalasi',
    ShortName: 'GMD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 38,
    Name: 'Ghanaian Cedi',
    ShortName: 'GHS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 39,
    Name: 'Ghanaian Cedi',
    ShortName: 'GHC',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 40,
    Name: 'Guinean Franc',
    ShortName: 'GNF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 41,
    Name: 'Hong Kong Dollar',
    ShortName: 'HKD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 42,
    Name: 'Greek Drachma',
    ShortName: 'GRD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 43,
    Name: 'Georgian Lari',
    ShortName: 'GEL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 44,
    Name: 'Danish Krone',
    ShortName: 'DKK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 45,
    Name: 'Macedonia Denar',
    ShortName: 'MKD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 46,
    Name: 'UAE Dirham',
    ShortName: 'AED',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 47,
    Name: 'Zimbabwe Dollar',
    ShortName: 'ZWD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 48,
    Name: 'Namibian Dollar',
    ShortName: 'NAD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 49,
    Name: 'US Dollar',
    ShortName: 'USD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 50,
    Name: 'Euro',
    ShortName: 'EUR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 51,
    Name: 'Egyptian Pound',
    ShortName: 'EGP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 52,
    Name: 'Zambian Kwacha',
    ShortName: 'ZMW',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 53,
    Name: 'Indian Rupee',
    ShortName: 'INR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 54,
    Name: 'Indonesian Rupiah',
    ShortName: 'IDR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 55,
    Name: 'Jordanian Dinar',
    ShortName: 'JOD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 56,
    Name: 'Iraqi Dinar',
    ShortName: 'IQD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 57,
    Name: 'Iranian Rial',
    ShortName: 'IRR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 58,
    Name: 'Irish Pound',
    ShortName: 'IEP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 59,
    Name: 'Icelandic Krona',
    ShortName: 'ISK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 60,
    Name: 'Spanish Peseta',
    ShortName: 'ESP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 61,
    Name: 'Italian Lira',
    ShortName: 'ITL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 62,
    Name: 'Yemeni Rial',
    ShortName: 'YER',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 63,
    Name: 'Kazakhstani Tenge',
    ShortName: 'KZT',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 64,
    Name: 'Cambodian Riel',
    ShortName: 'KHR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 65,
    Name: 'Canadian Dollar',
    ShortName: 'CAD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 66,
    Name: 'Qatari Riyal',
    ShortName: 'QAR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 67,
    Name: 'Kenyan Shilling',
    ShortName: 'KES',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 68,
    Name: 'Lao Kip',
    ShortName: 'LAK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 69,
    Name: 'Cypriot Pound',
    ShortName: 'CYP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 70,
    Name: 'Kyrgyzstani Som',
    ShortName: 'KGS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 71,
    Name: 'Chinese Yuan',
    ShortName: 'CNY',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 72,
    Name: 'Colombian Peso',
    ShortName: 'COP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 73,
    Name: 'Franc Congolais',
    ShortName: 'CDF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 74,
    Name: 'Costa Rican Colon',
    ShortName: 'CRC',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 75,
    Name: 'Cuban Peso',
    ShortName: 'CUP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 76,
    Name: 'Kuwaiti Dinar',
    ShortName: 'KWD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 77,
    Name: 'Latvian Lats',
    ShortName: 'LVL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 78,
    Name: 'Lebanese Pound',
    ShortName: 'LBP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 79,
    Name: 'Libyan Dinar',
    ShortName: 'LYD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 80,
    Name: 'Lithuanian Litas',
    ShortName: 'LTL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 81,
    Name: 'Mauritian Rupee',
    ShortName: 'MUR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 82,
    Name: 'Mauritania Ouguiya',
    ShortName: 'MRO',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 83,
    Name: 'Malawian Kwacha',
    ShortName: 'MWK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 84,
    Name: 'Malagasy Ariary',
    ShortName: 'MGA',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 85,
    Name: 'Malagasy Franc',
    ShortName: 'MGF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 86,
    Name: 'Malaysian Ringgit',
    ShortName: 'MYR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 87,
    Name: 'Maltese Lira',
    ShortName: 'MTL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 88,
    Name: 'Moroccan Dirham',
    ShortName: 'MAD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 89,
    Name: 'Mexican Peso',
    ShortName: 'MXN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 90,
    Name: 'Mozambican Metical',
    ShortName: 'MZN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 91,
    Name: 'Mozambican Metical',
    ShortName: 'MZM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 92,
    Name: 'Moldovan Leu',
    ShortName: 'MDL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 93,
    Name: 'Mongolian Tugrik',
    ShortName: 'MNT',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 94,
    Name: 'German Mark',
    ShortName: 'DEM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 95,
    Name: 'Nepalese Rupee',
    ShortName: 'NPR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 96,
    Name: 'Nigerian Naira',
    ShortName: 'NGN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 97,
    Name: 'Dutch Guilder',
    ShortName: 'NLG',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 98,
    Name: 'Nicaraguan Cordoba Oro',
    ShortName: 'NIO',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 99,
    Name: 'Turkish Lira',
    ShortName: 'TRY',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 100,
    Name: 'New Zealand Dollar',
    ShortName: 'NZD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 101,
    Name: 'New Zimbabwe Dollar',
    ShortName: 'ZWN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 102,
    Name: 'Israeli New Shekel',
    ShortName: 'ILS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 103,
    Name: 'Romanian Leu',
    ShortName: 'RON',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 104,
    Name: 'New Taiwan Dollar',
    ShortName: 'TWD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 105,
    Name: 'Norwegian Krone',
    ShortName: 'NOK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 106,
    Name: 'Omani Rial',
    ShortName: 'OMR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 107,
    Name: 'Pakistan Rupee',
    ShortName: 'PKR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 108,
    Name: 'Paraguay Guarani',
    ShortName: 'PYG',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 109,
    Name: 'Peruvian Nuevo Sol',
    ShortName: 'PEN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 110,
    Name: 'Polish Zloty',
    ShortName: 'PLN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 111,
    Name: 'Portuguese Escudo',
    ShortName: 'PTE',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 112,
    Name: 'Russian Ruble',
    ShortName: 'RUB',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 113,
    Name: 'Romanian Leu',
    ShortName: 'RON',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 114,
    Name: 'Special Drawing Rights',
    ShortName: 'XDR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 115,
    Name: 'Saudi Arabian Riyal',
    ShortName: 'SAR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 116,
    Name: 'Swazi Lilangeni',
    ShortName: 'SZL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 117,
    Name: 'North Korean won',
    ShortName: 'KPW',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 118,
    Name: 'Seychelles Rupee',
    ShortName: 'SCR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 119,
    Name: 'Serbian Dinar',
    ShortName: 'RSD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 120,
    Name: 'Serbian Dinar',
    ShortName: 'CSD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 121,
    Name: 'Singapore Dollar',
    ShortName: 'SGD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 122,
    Name: 'Syrian Pound',
    ShortName: 'SYP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 123,
    Name: 'Slovak Koruna',
    ShortName: 'SKK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 124,
    Name: 'Slovenian Tolar',
    ShortName: 'SIT',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 125,
    Name: 'Somali Shilling',
    ShortName: 'SOS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 126,
    Name: 'Sudanese Pound',
    ShortName: 'SDG',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 127,
    Name: 'Sudanese Dinar',
    ShortName: 'SDD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 128,
    Name: 'Suriname Guilder',
    ShortName: 'SRG',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 129,
    Name: 'Suriname Dollar',
    ShortName: 'SRD',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 130,
    Name: 'Sierra Leonean Leone',
    ShortName: 'SLL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 131,
    Name: 'Tajikistan Somoni',
    ShortName: 'SOM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 132,
    Name: 'Tajikistan Somoni',
    ShortName: 'TJS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 133,
    Name: 'Thai Baht',
    ShortName: 'THB',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 134,
    Name: 'Tanzanian Shilling',
    ShortName: 'TZS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 135,
    Name: 'Tunisian Dinar',
    ShortName: 'TND',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 136,
    Name: 'Turkish Lira',
    ShortName: 'TRL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 137,
    Name: 'Turkmenistan Manat',
    ShortName: 'TMM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 138,
    Name: 'Uganda Shilling',
    ShortName: 'UGX',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 139,
    Name: 'Uzbekistani Som',
    ShortName: 'UZS',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 140,
    Name: 'Ukrainian Hryvnia',
    ShortName: 'UAH',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 141,
    Name: 'Uruguayan peso',
    ShortName: 'UYU',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 142,
    Name: 'Philippine Peso',
    ShortName: 'PHP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 143,
    Name: 'Finnish Mark',
    ShortName: 'FIM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 144,
    Name: 'Djiboutian Franc',
    ShortName: 'DJF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 145,
    Name: 'Central African CFA',
    ShortName: 'XAF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 146,
    Name: 'West African CFA',
    ShortName: 'XOF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 147,
    Name: 'French Franc',
    ShortName: 'FRF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 148,
    Name: 'Pound Sterling',
    ShortName: 'GBP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 149,
    Name: 'Croatian Kuna',
    ShortName: 'HRK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 150,
    Name: 'Czech Koruna',
    ShortName: 'CZK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 151,
    Name: 'Chilean Peso',
    ShortName: 'CLP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 152,
    Name: 'Swedish Krona',
    ShortName: 'SEK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 153,
    Name: 'Swiss Franc',
    ShortName: 'CHF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 154,
    Name: 'Sri Lankan Rupee',
    ShortName: 'LKR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 155,
    Name: 'European Currency Unit',
    ShortName: 'XEU',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 156,
    Name: 'Estonian Kroon',
    ShortName: 'EEK',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 157,
    Name: 'Ethiopian Birr',
    ShortName: 'ETB',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 158,
    Name: 'New Yugoslavian Dinar',
    ShortName: 'YUN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 159,
    Name: 'South African Rand',
    ShortName: 'ZAR',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 160,
    Name: 'Japanese Yen',
    ShortName: 'JPY',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 161,
    Name: 'Dominican Peso',
    ShortName: 'DOP',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 162,
    Name: 'USDT TRC 2.0 token',
    ShortName: 'UST',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 163,
    Name: 'Zimbabwean dollar',
    ShortName: 'ZWL',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 164,
    Name: 'Play for fun',
    ShortName: 'FUN',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 165,
    Name: 'Bosnia-Herzegovina Convertible Marka',
    ShortName: 'BAM',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 166,
    Name: 'Rwandan francs',
    ShortName: 'RWF',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 167,
    Name: 'Micro BTC uBTC',
    ShortName: 'UBC',
    DecimalPoint: 2,
  },
  {
    CurrencyID: 168,
    ShortName: 'TRX',
    Name: 'TRON crypto currency',
    DecimalPoint: 2,
  },
]
